import {appTasks, postData} from "../../utils/Utils.js";

const PostList = (domEl) => {

	// The "views"
	const timeline = domEl.querySelector('.timeline');
	const loadMoreBtn = domEl.querySelector('.load-more-button');
	const noPostsEl = domEl.querySelector('.no-posts');
	const totalResultsEl = domEl.querySelector('.total-results-heading');

	// "State management"
	let isLocked = false;
	let resetBeforeAppending = false;
	let allFetched = ( loadMoreBtn ? loadMoreBtn.style.display === 'none' : true ); // TODO: More "strict" solution ;)
	let timeoutPreloader = null;

	// FormData to send
	const categories = domEl.getAttribute('data-categories');
	const headingLevel = domEl.getAttribute('data-heading-level');

	const postsPerPage = parseInt(domEl.getAttribute('data-posts_per_page'));
	let offset = parseInt(domEl.getAttribute('data-offset'));

	const getBatch = (e) => {
		if(e) {
			e.preventDefault();
		}
		render();
	};

	const render = () => {

		if(isLocked) {
			return;
		}
		isLocked = true;

		// The FormData submitted
		const formData = new FormData();

		// Append nonce and the action so the ajax callback
		const task = appTasks.loadPosts; // From theme-setup.php
		formData.append('action', task.action);
		formData.append('nonce', task.nonce);
		formData.append('posts_per_page', postsPerPage);
		formData.append('offset', offset);
		formData.append('heading-level', headingLevel);

		const searchParams = new URLSearchParams(window.location.search);
		if(searchParams.get('kategori')) {
			formData.append('categories', searchParams.get('kategori').split('+'));
		}
		else if(categories) {
			formData.append('categories', categories);
		}
		if(searchParams.get('soeg')) {
			formData.append('soeg', searchParams.get('soeg'));
		}

		// Preloader begin
		clearTimeout(timeoutPreloader);
		timeoutPreloader = setTimeout(showPreloader, 1);

		postData(task.url, formData)
			.then(response => {
				// Preloader end
				clearTimeout(timeoutPreloader);
				showPreloader(false);

				if(!response.success) {
					//showGenericError();
					isLocked = false;
				}
				else {

					const lastPostBeforeAppend = timeline.lastElementChild;

					if(resetBeforeAppending) {
						timeline.innerHTML = '';
					}

					timeline.insertAdjacentHTML('beforeend', response.data.list);
					offset += postsPerPage;

					let postToFocus;

					// Scenario 1: We've reset the timeline, so focus on its first child
					if(resetBeforeAppending) {
						postToFocus = timeline.firstElementChild;
					}
					else if(lastPostBeforeAppend) { // Scenario 2: We've added to the timeline, so focus on the post after the previous last post
						postToFocus = lastPostBeforeAppend.nextElementSibling;
					}

					// Check if postToFocus is valid and focus on its permalink
					if(postToFocus) {
						const permalinkInsidePostToFocus = postToFocus.querySelector('.permalink-heading');

						// If the permalink isn't naturally focusable, make it so by setting its tabindex
						if(permalinkInsidePostToFocus && !permalinkInsidePostToFocus.hasAttribute('tabindex')) {
							permalinkInsidePostToFocus.setAttribute('tabindex', '0');
						}

						// Now, set focus to the permalink
						permalinkInsidePostToFocus && permalinkInsidePostToFocus.focus();
					}
				}

				resetBeforeAppending = false;
				allFetched = parseInt(response.data.listCount) <= offset;

				// Load more or no offers?
				toggleLoadMoreBtnVisibility( parseInt(response.data.listCount) > offset );
				toggleNoPosts(parseInt(response.data.listCount) <= 0);

				// Update the "Total Results" text
				if(totalResultsEl) {
					totalResultsEl.textContent = ( totalResultsEl.dataset.text.replace('[NUM]', response.data.listCount) );
				}

				// Update the history so we can go back and forth
				if(parseInt(response.data.listBatchCount) > 0) {
					const searchParams = new URLSearchParams(window.location.search);
					const side = resetBeforeAppending ? 0 : searchParams.get('side') ? searchParams.get('side') : 1;
					searchParams.set('side', String(side ? parseInt(side) + 1 : 1));
					window.history.replaceState(null, null, `${window.location.pathname}?${searchParams.toString()}`);
				}

				// Unlock so we're ready for the next batch
				isLocked = false;
			})
			.catch(function(err) {
				//console.log(err);
				isLocked = false;
				clearTimeout(timeoutPreloader);
				showPreloader(false);
			});
	};

	const toggleLoadMoreBtnVisibility = (show) => {
		if(loadMoreBtn) {
			loadMoreBtn.style.display = ( show ? 'block' : 'none' );
		}
	};
	const toggleNoPosts = (show) => {
		if(noPostsEl) {
			noPostsEl.style.display = ( show ? 'block' : 'none' );
		}
	};
	const showPreloader = (show = true) => {
		//console.log('showPreloader', show);
	}

	// Load more
	if(loadMoreBtn) {
		loadMoreBtn.addEventListener('click', getBatch);
	}
};

export default PostList;